import { PillarPage, SearchPageCity } from 'src/constants/searchPages'
import { RedirectUrls } from 'src/types/types'
import { HygraphTopics } from 'src/utils/hygraph'

export type FooterTranslationKey =
  | 'FOOTER.STORAGE_TYPES'
  | 'FOOTER.MINI_STORAGE'
  | 'FOOTER.ON_DEMAND'
  | 'FOOTER.COMMERCIAL_WAREHOUSE'
  | 'FOOTER.PARKING'
  | 'FOOTER.INDUSTRIAL'
  | 'FOOTER.LOGISTICS_SOLUTIONS'
  | 'FOOTER.BUSINESS_USES'
  | 'FOOTER.CAR_DEALERS'
  | 'FOOTER.ECOMMERCE'
  | 'FOOTER.LOGISTICS'
  | 'FOOTER.CONSTRUCTION'
  | 'FOOTER.TRANSPORT'
  | 'FOOTER.FLOTILLAS'
  | 'FOOTER.OFFICE_PARKING'
  | 'FOOTER.LOCATIONS'
  | 'FOOTER.CDMX'
  | 'FOOTER.GUADALAJARA'
  | 'FOOTER.MONTERREY'
  | 'FOOTER.QUERETARO'
  | 'FOOTER.PUEBLA'
  | 'FOOTER.MONETIZE'
  | 'FOOTER.UPLOAD'
  | 'FOOTER.REFER'
  | 'FOOTER.CALCULATE'
  | 'FOOTER.NEGOCIO'
  | 'FOOTER.TRADICIONAL'
  | 'FOOTER.PARKING_HOST'
  | 'FOOTER.BODEGAS'
  | 'FOOTER.LOGISTICS_HOST'
  | 'FOOTER.BUSINESS_SOLUTIONS'
  | 'FOOTER.BROKER'
  | 'FOOTER.MULTIFAMILY'
  | 'FOOTER.HELP'
  | 'FOOTER.HELP_CENTER'
  | 'FOOTER.FAQS'
  | 'FOOTER.CONTACT'
  | 'FOOTER.SECURITY'
  | 'FOOTER.SEGURO'
  | 'FOOTER.REFUND_POLICY'
  | 'FOOTER.DISPUTES_POLICY'
  | 'FOOTER.HOST_HELP'
  | 'FOOTER.RENTER_HELP'
  | 'FOOTER.BLOG'
  | 'FOOTER.STORAGE_TIPS'
  | 'FOOTER.CUSTOMER_STORIES'
  | 'FOOTER.ABOUT_US'
  | 'FOOTER.MEDIA'
  | 'FOOTER.DEVELOPERS'
  | 'FOOTER.LATEST_POSTS'
  | 'FOOTER.STORAGE_GUIDE'
  | 'FOOTER.SIZE_GUIDE'
  | 'FOOTER.TERMS'
  | 'FOOTER.PRIVACY'
  | 'FOOTER.SITEMAP'

/** Visibility gate keys; resolved at render time by the Footer component. */
export type FooterGate = 'on-demand-coverage'

export type IItemProps = {
  href: RedirectUrls | string
  children: FooterTranslationKey
  /** When set, Footer omits this link unless the gate resolves to `true`. */
  gateBy?: FooterGate
}

// Storage Types Section
export const STORAGE_TYPES_LINKS: IItemProps[] = [
  {
    href: `/${PillarPage.SelfStorage}`,
    children: 'FOOTER.MINI_STORAGE'
  },
  {
    href: `/${PillarPage.SelfStorage}/almacenamiento-a-domicilio`,
    children: 'FOOTER.ON_DEMAND',
    gateBy: 'on-demand-coverage'
  },
  {
    href: `/${PillarPage.Warehouse}`,
    children: 'FOOTER.COMMERCIAL_WAREHOUSE'
  },
  {
    href: `/${PillarPage.Parking}`,
    children: 'FOOTER.PARKING'
  },
  {
    href: `/${PillarPage.Industrial}`,
    children: 'FOOTER.INDUSTRIAL'
  },
  {
    href: RedirectUrls.SolucionesLogisticas,
    children: 'FOOTER.LOGISTICS_SOLUTIONS'
  },
  {
    href: RedirectUrls.SizeGuide,
    children: 'FOOTER.SIZE_GUIDE'
  }
]

// Business Uses Section
export const BUSINESS_USES_LINKS: IItemProps[] = [
  {
    href: `/${PillarPage.Warehouse}`,
    children: 'FOOTER.CAR_DEALERS'
  },
  {
    href: `/${PillarPage.Warehouse}`,
    children: 'FOOTER.ECOMMERCE'
  },
  {
    href: `/${PillarPage.Warehouse}`,
    children: 'FOOTER.LOGISTICS'
  },
  {
    href: `/${PillarPage.Parking}`,
    children: 'FOOTER.CONSTRUCTION'
  },
  {
    href: `/${PillarPage.Parking}/flotillas`,
    children: 'FOOTER.FLOTILLAS'
  },
  {
    href: `/${PillarPage.Parking}`,
    children: 'FOOTER.OFFICE_PARKING'
  }
]

// Popular Cities Section
export const POPULAR_CITIES: IItemProps[] = [
  {
    href: `/${PillarPage.SelfStorage}/${SearchPageCity.CiudadDeMexico}`,
    children: 'FOOTER.CDMX'
  },
  {
    href: `/${PillarPage.SelfStorage}/${SearchPageCity.Guadalajara}`,
    children: 'FOOTER.GUADALAJARA'
  },
  {
    href: `/${PillarPage.SelfStorage}/${SearchPageCity.Monterrey}`,
    children: 'FOOTER.MONTERREY'
  },
  {
    href: `/${PillarPage.SelfStorage}/${SearchPageCity.Queretaro}`,
    children: 'FOOTER.QUERETARO'
  },
  {
    href: `/${PillarPage.SelfStorage}/${SearchPageCity.Puebla}`,
    children: 'FOOTER.PUEBLA'
  }
]

// Monetization Section
export const MONETIZE_LINKS: IItemProps[] = [
  {
    href: RedirectUrls.Anfitrion,
    children: 'FOOTER.UPLOAD'
  },
  {
    href: RedirectUrls.Refer,
    children: 'FOOTER.REFER'
  },
  {
    href: RedirectUrls.Calculate,
    children: 'FOOTER.CALCULATE'
  },
  {
    href: RedirectUrls.Negocio,
    children: 'FOOTER.NEGOCIO'
  },
  {
    href: RedirectUrls.Tradicional,
    children: 'FOOTER.TRADICIONAL'
  },
  {
    href: RedirectUrls.Estacionamiento,
    children: 'FOOTER.PARKING_HOST'
  },
  {
    href: RedirectUrls.Bodegas,
    children: 'FOOTER.BODEGAS'
  },
  {
    href: RedirectUrls.AnfitrionLogistica,
    children: 'FOOTER.LOGISTICS_HOST'
  }
]

// Business Solutions Section
export const BUSINESS_SOLUTIONS_LINKS: IItemProps[] = [
  {
    href: RedirectUrls.Broker,
    children: 'FOOTER.BROKER'
  },
  {
    href: '/business/multifamily',
    children: 'FOOTER.MULTIFAMILY'
  }
]

// Help Section
export const HELP_LINKS: IItemProps[] = [
  {
    href: RedirectUrls.Help,
    children: 'FOOTER.HELP_CENTER'
  },
  {
    href: `${RedirectUrls.Help}/${HygraphTopics.HelpFaq}/preguntas-frecuentes`,
    children: 'FOOTER.FAQS'
  },
  {
    href: RedirectUrls.Contact,
    children: 'FOOTER.CONTACT'
  },
  {
    href: RedirectUrls.Disclosures,
    children: 'FOOTER.SECURITY'
  },
  {
    href: RedirectUrls.Seguro,
    children: 'FOOTER.SEGURO'
  },
  {
    href: RedirectUrls.Reembolso,
    children: 'FOOTER.REFUND_POLICY'
  },
  {
    href: RedirectUrls.Disputas,
    children: 'FOOTER.DISPUTES_POLICY'
  },
  {
    href: RedirectUrls.Directory,
    children: 'FOOTER.SITEMAP'
  }
]

// Blog Section
export const BLOG_LINKS: IItemProps[] = [
  {
    href: RedirectUrls.Blog,
    children: 'FOOTER.LATEST_POSTS'
  },
  {
    href: RedirectUrls.Nosotros,
    children: 'FOOTER.ABOUT_US'
  },
  {
    href: RedirectUrls.Medios,
    children: 'FOOTER.MEDIA'
  },
  {
    href: RedirectUrls.Desarrolladores,
    children: 'FOOTER.DEVELOPERS'
  }
]
